<nav class="navbar navbar-expand-lg navbar-light bg-light primary">
	<span class="navbar-brand"><img src="../../assets/images/nesten-logo.png" alt="" class="img-fluid" style="height: 40px;"></span>
	<span class="headerSpace"></span>
	<i class="fa fa-bars" aria-hidden="true" (click)="openDialog()" style="font-size: x-large; cursor:pointer;"></i>
</nav>
<div class="main-div py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12" *ngIf="!locked">
                <h2 class="title">Export</h2>
                <div class="form-holder">
                    <div>
                        <div>
                            <!-- <mat-form-field class="example-full-width">
                                <input class="primary" [(ngModel)]="seed" matInput placeholder="Seed Word">
                            </mat-form-field> -->
                            <h4 class="text-center text-white mt-4 font-weight-bold">Do not share this words to anyone they will have access to all of your wallet</h4>
                            <ul class="list-unstyled custom-wallet-list my-5">
                                <li *ngFor="let word of seed">{{word}}</li>

                            </ul>
                        </div>
                        <ngx-qrcode [qrc-value]="raswSeed" qrc-class="aclass mb-4 qrc-code-area text-center" qrc-errorCorrectionLevel="L">
                        </ngx-qrcode>
                        <div class="row">
                            <div class="col-6">
                                <button mat-stroked-button class="primary border-gradient-btn mb-2" (click)="route('dashboard')">Back</button>
                            </div>
                            <div class="col-6 text-right">
                                <button mat-stroked-button class="primary  solid-gradient-btn mb-2" (click)="downloadAsText()">Save As Text</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-md-6" *ngIf="locked">
                <h2 class="title">Export Wallet</h2>
                <div class="form-holder">
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field class="example-full-width">
                                <input class="primary" type="password" [(ngModel)]="passPhrase" matInput placeholder="Pass Phrase">
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <button mat-stroked-button class="primary solid-gradient-btn mb-2" (click)="route('dashboard')">Back</button>
                        </div>
                        <div class="col-6 text-right">
                            <button mat-stroked-button class="primary solid-gradient-btn mb-2" (click)="reveal()">Confirm</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
